import React, { useEffect, useState, useContext} from 'react'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { DataGrid, GridToolbar} from '@mui/x-data-grid'
import Typography from '@mui/material/Typography';
import { Button, CardActionArea, CardActions } from '@mui/material';
import '../../styles/PeoplesSuggestionsMobUI.css';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import TextField from "@mui/material/TextField";
import { Container } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useSearchParams } from 'react-router-dom';
import { UserContext } from '../UserContext';
import Grid from '@mui/material/Grid';
import { useNavigate } from "react-router-dom";
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Checkbox from '@mui/material/Checkbox';
import SuggestionPageIntroPopUp from '../SuggestionPageIntroPopUp';
import SuggestionsMobUI from '../MobUI/SuggestionsMobUI';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const style5 = {
  position: 'relative',
  margin:"auto",
  height: "auto",
  minWidth: 325,
  maxWidth: 385,
  scrollY:"auto",
  bgcolor: 'background.paper',
  border: '2px solid #000',

};

const PeoplesSuggestionsMobUI = (props) => {

//UseState
var navigate = useNavigate();
const { user, setUser} = useContext(UserContext);
const [users,setUsers] = useState("");
const [ allStatus,setAllStatus] = useState("");
const [follow,setFollow] = useState("");
const [openModel,setOpenModel] = useState(false);
const [intro,setIntro] = useState("");
const [cid,setCId] = useState("");
const [name,setName] = useState("");
const [statusReq,setReqq] = useState("");
const [selectedCommunity,setSelectedCommunity] = useState([])
const [communities,setCommunities] = useState([]);
const [openIntroModal,setOpenIntroModal] = useState(false);
const [introData,setIntroData] = useState(false);


 //UseEffect
//  useEffect(()=>{
//   getAllUsers()
  
// },[user]) 
  
const ConnectionReq = async (id,name,status)=>{
  let confirmation=window.confirm("Are you sure ?")
  if(!confirmation){
    return
  }
    let apiURL=process.env.REACT_APP_API_URL + "/connection/addconnections";
    let apiParams = {
        method:"POST",
        headers:{
          user1id:user._id,
          user1name:user.name,
          status:status,
           user2id:id,
           user2name:name,  
           intro:encodeURIComponent(intro),
           user1selectedcommunity:encodeURIComponent(JSON.stringify(selectedCommunity)),
        },
        
    };
    fetch(apiURL, apiParams)
    .then((res)=> (res.status===200 ? res.json() : res.text()))
    .then((repos)=> {
        if (repos.data) {
      
          alert("Action Updated Successfully!!");
          
      //    props.showAlert("Job Added Successfully","success")
      
        }else alert(repos.message || repos);
    }) 
    .catch((err) => alert(err)); 
}

const openModal = (id,name)=>{

  setOpenModel(true);
  setCId(id);
  setName(name);

}


const getStatus = ()=>{
 
  let apiURL = process.env.REACT_APP_API_URL + "/connection/getstatus/" + user._id;
  let apiParams = {
    method: "GET",
  };
  fetch(apiURL, apiParams)
    .then((res) => (res.status === 200 ? res.json() : res.text()))
    .then((repos) => {
      if (repos.data) {
          console.log(repos.data)
          setAllStatus(repos.data)
      } else alert(repos.message || repos);
    })
    .catch((err) => alert(err));
};


//Converting Image
function arrayBufferToBase64(buffer) {
  var binary = "";
  var bytes = [].slice.call(new Uint8Array(buffer));
  bytes.forEach((b) => (binary += String.fromCharCode(b)));
  var base64Flag = "data:image/jpeg;base64,";
  return base64Flag + window.btoa(binary);
}

const getAllUsers = ()=>{
    let apiURL = process.env.REACT_APP_API_URL + "/users/getUserSuggestions/"+user._id;
    let apiParams = {
      method: "GET",
    };
    fetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {
            console.log(repos.data)
         setUsers(repos.data)
        } else alert(repos.message || repos);
      })
      .catch((err) => alert(err));
};

const setCloseModel = ()=>{
  setOpenModel(false);
}
  
const closeModel = () => setOpenModel(false);

const addIntro = ()=>{

  ConnectionReq(cid,name,"Requested");
  setOpenModel(false)

}


const openConnectionModal = (id,name)=>{
  
setIntroData({id,name})
 setOpenIntroModal(true)
}

  return (
<div id="people_sugg">
	<div id="heading_grp_conreqsug_mob__sug">
		<div id="req_conreqsug_mob__sug" onClick={()=>props.selectedTab("Requests")}>
			<span>Requests</span>
		</div>
		<div id="selected_grp_conreqsug_mob__su">
			<div id="con_conreqsug_mob__sug" onClick={()=>props.selectedTab("Connections")}>
				<span>Connections</span>
			</div>
		</div>
		<div id="sug_conreqsug_mob__sug">
			<span>Suggestions</span>
		</div>
		<svg class="underline_conreqsug_mob__sug">
			<rect id="underline_conreqsug_mob__sug" rx="0" ry="0" x="0" y="0" width="81" height="3">
			</rect>
		</svg>
	</div>
  <SuggestionsMobUI />
</div>

  )
}

export default PeoplesSuggestionsMobUI
